import styled from 'styled-components';

export const CalculatorBox = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.results
      ? 'repeat(1, 1fr)'
      : props.aplus
        ? 'repeat(1, 1fr)'
        : 'repeat(2, 1fr)'};
  background: ${(props) =>
    props.ovulation ? 'hsl(338deg 100% 96% / 60%)' : '#eaf7fcab'};
  padding: ${(props) =>
    props.results ? '1em' : props.aplus ? '1em' : '3em 2em'};
  margin: ${(props) =>
    props.results ? '1em 0em' : props.aplus ? '1em' : '1em 6em'};
  border-radius: 14px;
  align-items: center;
  @media (max-width: 720px) {
    width: ${(props) => (props.results ? 'calc(100% + 24px)' : '100%')};
    grid-template-columns: repeat(1, 1fr);
    margin: ${(props) =>
      props.results ? '1em 0 1em -14px' : props.aplus ? '0' : '1em 1em'};
    padding: 2em 1em;
  }

  & .centerImage {
    position: relative;
    padding-top: 48%;
    display: ${(props) => (props.aplus ? 'none' : 'block')};
    @media (max-width: 720px) {
      padding-top: 61.5%;
      margin-bottom: 6px;
    }
  }
`;

export const CalculatorImage = styled.img`
  width: 100%;
  max-width: 260px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  margin: auto;
  right: 0;

  @media (max-width: 720px) {
    width: 70%;
    margin-top: 0px;
  }
`;

export const Calculator = styled.div`
  padding-right: 20px;

  & h1 {
    color: hsl(0deg 0% 0% / 87%);
    text-transform: uppercase;
    font-weight: 700;
    padding: 4px 0 12px;
    font-size: clamp(21px, 5vw, 32px);
  }

  & .spacingTop {
    padding-top: 26px;

    & h5 {
      font-size: 15px;
      color: hsl(0deg 0% 0% / 88%);
      font-weight: 600;
    }
  }

  & .noSpacingTop {
    padding-top: 0;

    & h5 {
      font-size: 15px;
      color: hsl(0deg 0% 0% / 88%);
      font-weight: 600;
    }
  }

  & p {
    font-size: 15px;
    color: hsl(0deg 0% 0% / 87%);
  }

  @media (max-width: 720px) {
    text-align: ${(props) =>
      props.categoryPage || props.results ? ' left' : ' center'};
    padding-right: 0;
  }

  select option[disabled] {
    display: none;
  }
`;

export const SelectDate = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  padding: 22px 140px 13px 0;

  & select {
    padding: 12px 8px;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 500;
    color: #6e6e6e;
    cursor: pointer;
    font-family: 'Montserrat';
  }

  @media (max-width: 720px) {
    padding: 22px 0 10px;
  }
`;

export const DateCalculateBtn = styled.div`
  width: 90%;
  border: none;
  outline: none;
  height: 48px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  line-height: 48px;
  color: #fff;
  font-weight: 700;
  background: #ef4e5e;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
  font-family: 'Montserrat';
  text-align: center;
`;
export const ErrorText = styled.span`
  font-size: clamp(12px, 1.1vw, 14px);
  font-weight: 500;
  color: #ef4e5e;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  padding-bottom: 12px;
  display: inline-block;

  @media (max-width: 720px) {
    height: ${(props) => (props.preg ? '27.2px' : 'auto')};
  }
`;
